/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_RefreshInputs */



/**
* | output |
* | --- |
* | "Refresh status" |
*
* @param {Admin_Status_RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_refresh = /** @type {((inputs?: Admin_Status_RefreshInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_RefreshInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser l'état")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atualizar status")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna stato")
	return /** @type {LocalizedString} */ ("Refresh status")
});